import { LoadingStates } from '@pb/utils'

export default {
  loginStatus: LoadingStates.NotLoaded,
  loginErrors: [],

  proceedToCheckoutStatus: LoadingStates.NotLoaded,

  loyaltyBenefitsStatus: LoadingStates.NotLoaded,
  loyaltyBenefits: [],
}
